import React from "react";
import { Stack, Typography } from "@mui/material";
import { Tag } from "src/components/Tag";

type Props = {
  label: string;
  value: string | undefined;
  required?: boolean;
  optional?: boolean;
};

export default function ConfirmItem({ label, value, required, optional }: Props) {
  return (
    <Stack spacing={1}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography fontWeight="bold" sx={{ display: "flex", alignItems: "center" }}>
          {label}
        </Typography>
        {required && <Tag label="必須" color="secondary" />}
        {optional && <Tag label="任意" color="info" />}
      </Stack>
      <Typography>{value || "-"}</Typography>
    </Stack>
  );
}
